<template>
  <div class="">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <p class="mb-0">{{ $t("esim_total") }}: {{ totalOrder }}</p>
      <div
        @click="handleShowFilter"
        class="d-flex justyfy-content-center align-items-center gap-2"
      >
        <p class="mb-0">{{ $t("esim_filter") }}</p>
        <img src="@/static/icon_filter.svg" width="20" height="20" alt="" />
      </div>
    </div>
    <!-- <van-list v-model:loading="isLoading" :finished="isFinished" :loading-text="$t('no_more_data')" -->
    <van-list
      :loading="isLoading"
      :finished="isFinished"
      :loading-text="$t('no_more_data')"
      @load="loadMore"
    >
      <CardOrder
        :listOrderEsim="listOrderEsimABA"
        @handleGoToDetail="handleGoToDetail"
      />
    </van-list>
    <!-- 
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model:loading="isLoading" :finished="isFinished" finished-text="Finished" @load="loadMore">
                <CardOrder :listOrderEsim="listOrderEsimABA" @handleGoToDetail="handleGoToDetail" />
            </van-list>
        </van-pull-refresh> -->
    <div
      v-if="!isLoading && listOrderEsimABA.length === 0"
      class="d-flex justify-content-center align-items-center min-vh-100"
    >
      <van-empty image="search" />
    </div>

    <!-- <van-empty v-if="!isLoading && listOrderEsimABA.length === 0" image="search"
            :description="$t('esim_similar_not_found')" /> -->
  </div>

  <van-popup v-model:show="showFilter" round :style="{ height: 'auto' }">
    <div class="p-4">
      <div class="mb-3 d-flex justify-content-end">
        <van-button class="btn btn-close-popup" block @click="handleClose">
          <van-icon name="cross" width="20" height="20" />
        </van-button>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3 gap-3">
        <div class="">
          <label for="fromDate" class="text-capitalize"
            >{{ $t("esim_from") }}:</label
          >
          <van-field
            v-model="searchParams.fromDate"
            readonly
            name="fromDate"
            :placeholder="$t('esim_select_date')"
            @click="handleShowDatePicker(1)"
            class="p-0"
            right-icon="edit"
          />
        </div>
        <div class="">
          <label for="fromDate" class="text-capitalize"
            >{{ $t("esim_to") }}:</label
          >
          <van-field
            v-model="searchParams.toDate"
            readonly
            name="toDate"
            :placeholder="$t('esim_select_date')"
            @click="handleShowDatePicker(2)"
            class="p-0"
            right-icon="edit"
          />
        </div>
      </div>
      <van-divider dashed></van-divider>
      <div class="mb-3">
        <van-field
          v-model="transactionTypeText"
          readonly
          name="transactionType"
          :placeholder="$t('esim_select_transaction_type')"
          @click="showTransactionType = true"
          class="border rounded-3"
          right-icon="play"
        />
      </div>
      <div class="mb-3">
        <van-field
          v-model="statusText"
          readonly
          name="status"
          :placeholder="$t('esim_select_status')"
          @click="showStatus = true"
          class="border rounded-3"
          right-icon="play"
        />
      </div>
      <div class="mb-3">
        <van-field
          v-model="searchParams.orderCode"
          name="orderCode"
          :placeholder="$t('esim_input_order_code')"
          maxlength="15"
          class="border rounded-3"
        />
      </div>
      <div class="mb-4">
        <van-field
          v-model="searchParams.phoneNumber"
          name="phoneNumber"
          type="digit"
          inputmode="numeric"
          :placeholder="$t('esim_input_phone_number')"
          maxlength="15"
          class="border rounded-3"
        />
      </div>
      <div class="mb-3">
        <van-button
          class="btn btn-primary rounded-3 shadown-primary"
          block
          @click="handleSearch"
          >{{ $t("esim_search") }}</van-button
        >
      </div>
    </div>
  </van-popup>

  <!-- Popup Picker: transaction type -->
  <div class="w-100">
    <van-popup
      v-model:show="showTransactionType"
      destroy-on-close
      position="bottom"
    >
      <van-picker
        :model-value="transactionTypePickerValue"
        :columns="columnsTransactionType"
        @confirm="onConfirmTransactionType"
        @cancel="showTransactionType = false"
        :cancel-button-text="$t('close_cancel')"
        :confirm-button-text="$t('close_comfirm')"
      />
    </van-popup>
  </div>

  <!-- Popup DatePiker -->
  <div class="w-100">
    <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
      <van-date-picker
        :model-value="pickerValue"
        @confirm="onConfirmDatePiker"
        @cancel="showPicker = false"
        :columns-type="columnsType"
        :cancel-button-text="$t('close_cancel')"
        :confirm-button-text="$t('close_comfirm')"
      />
    </van-popup>
  </div>

  <!-- Popup Picker: status -->
  <div class="w-100">
    <van-popup v-model:show="showStatus" destroy-on-close position="bottom">
      <van-picker
        :model-value="searchParams.status"
        :columns="columnsStatus"
        @confirm="onConfirmStatus"
        @cancel="showStatus = false"
        :cancel-button-text="$t('close_cancel')"
        :confirm-button-text="$t('close_comfirm')"
      />
    </van-popup>
  </div>
</template>
<script>
import { Button } from "vant";
import { Row, Col } from "vant";
import { Popup } from "vant";
import { DatePicker, Picker } from "vant";
import { Field } from "vant";
import { Divider } from "vant";
import {
  formatDateToDDMMYYYY,
  splitDDMMYYYYtoPickerArray,
  formatArrayToDDMMYYYY,
} from "../../ultis/dateFormat";
import getErrorMessage from "@/helpers/error-server";
import CardOrder from "../../components/card/card-order.vue";
import { mapState } from "vuex";
import { CONSTANTS } from "@/helpers/constants";
import { List } from "vant";

function getDefaultSearchDateRange() {
  const toDate = new Date();
  const fromDate = new Date(toDate);
  fromDate.setDate(fromDate.getDate() - 30);
  return {
    fromDate: formatDateToDDMMYYYY(fromDate),
    toDate: formatDateToDDMMYYYY(toDate),
  };
}

export default {
  name: "Order",
  components: {
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    [DatePicker.name]: DatePicker,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Divider.name]: Divider,
    [List.name]: List,
    CardOrder,
  },
  data() {
    return {
      showFilter: false,
      showPicker: false,
      pickerValue: [],
      flagPicker: 0,
      columnsType: ["day", "month", "year"],
      showStatus: false,
      showTransactionType: false,
      transactionTypeText: "",
      columnsTransactionType: [
        { text: this.$t("esim_all"), value: "" },
        { text: this.$t("esim_transaction_buy_esim"), value: "BUY_ESIM" },
        {
          text: this.$t("esim_transaction_change_esim"),
          value: "CHANGE_ESIM",
        },
      ],
      columnsStatus: [
        { text: this.$t("esim_all"), value: "" },
        { text: this.$t("esim_status_fail"), value: "1" },
        { text: this.$t("esim_status_waiting"), value: "2" },
        { text: this.$t("esim_status_success"), value: "3" },
        { text: this.$t("esim_status_expired"), value: "4" },
      ],
      statusText: "",
      listOrderEsimABA: [],
      requestedPages: new Set(),
      searchParams: {
        ...getDefaultSearchDateRange(),
        status: [],
        orderCode: "",
        phoneNumber: "",
        transactionType: "",
        pageSize: 10,
        pageNumber: 1,
      },
      isLoading: false,
      isFinished: false,
      totalOrder: 0,
    };
  },
  async created() {
    this.handleGetListHistoryEsimABA(false);
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("headerStore", ["title"]),
    transactionTypePickerValue() {
      const v = this.searchParams.transactionType;
      return v === "" || v == null ? [""] : [v];
    },
  },
  mounted() {
    // this.changeTitle(this.$t(this.title));
  },
  watch: {
    // $route: {
    //   handler: function (value) {
    //     this.$store.dispatch("headerStore/setTitle", "esim_my_ordered");
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    // changeTitle(title) {
    //   const contentData = {
    //     title: title,
    //    color: "#ffffff",
    //     bgColor: this.color_primary(),
    //   };
    //   this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    // },
    handleClose() {
      this.showFilter = false;
    },
    handleShowDatePicker(flag) {
      this.flagPicker = flag;
      this.showPicker = true;
      const dateStr =
        flag === 1
          ? this.searchParams.fromDate || formatDateToDDMMYYYY(new Date())
          : this.searchParams.toDate || formatDateToDDMMYYYY(new Date());
      this.pickerValue = splitDDMMYYYYtoPickerArray(dateStr);
    },

    onConfirmDatePiker(value) {
      const values = value?.selectedValues || [];
      if (values.length === 0) return;

      if (this.flagPicker === 1) {
        this.searchParams.fromDate = formatArrayToDDMMYYYY(values);
      } else {
        this.searchParams.toDate = formatArrayToDDMMYYYY(values);
      }
      this.showPicker = false;
    },

    onConfirmStatus({ selectedValues, selectedOptions }) {
      this.statusText = selectedOptions[0]?.text;
      this.searchParams.status = selectedValues;
      this.showStatus = false;
    },

    onConfirmTransactionType({ selectedValues, selectedOptions }) {
      this.transactionTypeText = selectedOptions[0]?.text || "";
      this.searchParams.transactionType = selectedValues[0] ?? "";
      this.showTransactionType = false;
    },

    handleShowFilter() {
      this.showFilter = !this.showFilter;
    },

    handleGoToDetail(item) {
      this.$store.dispatch("esimBuyStore/itemOrderDetail", item);
      this.$store.dispatch("routerStore/setIsBackToHomeFromOrder", false);
      if (item) {
        this.$router.push({ path: "/my-order/detail" });
      }
    },

    loadMore() {
      // console.log("pageNumner", this.searchParams.pageNumber);
      this.handleGetListHistoryEsimABA(true);
    },

    handleSearch() {
      this.searchParams.pageNumber = 1; // Sửa ở đây
      this.isFinished = false;
      this.listOrderEsimABA = [];
      this.requestedPages.clear();
      this.handleGetListHistoryEsimABA(false);
      this.showFilter = false;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },

    normalizeHistoryList(result) {
      const raw =
        result?.orderedNumbers ??
        result?.historyList ??
        result?.list ??
        result?.orders ??
        result?.output ??
        result;

      const toArray = (value) => {
        if (Array.isArray(value)) return value;
        if (value) return [value];
        return [];
      };

      const normalizeItem = (item) => {
        if (!item || typeof item !== "object") return item;
        return {
          ...item,
          orderDate:
            item.orderDate || item.createDate || item.create_date || item.date || "",
          expiredTime: item.expiredTime || item.expired_time || "",
          status: item.status != null ? Number(item.status) : item.status,
          statusStr: item.statusStr || item.status_str || item.status || "",
          phone: item.phone || item.phoneNumber || item.msisdn || "",
        };
      };

      return toArray(raw).map(normalizeItem);
    },

    dedupeOrderList(list) {
      const seen = new Set();
      return list.filter((item) => {
        const key =
          item.orderCode ||
          item.id ||
          `${item.phone || ''}-${item.orderDate || ''}-${JSON.stringify(item)}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },

    parseDDMMYYYY(dateStr) {
      const s = (dateStr || "").toString().trim();
      const parts = s.split("/");
      if (parts.length !== 3) return null;
      const [dd, mm, yyyy] = parts;
      const d = Number(dd);
      const m = Number(mm);
      const y = Number(yyyy);
      if (!d || !m || !y) return null;
      const dt = new Date(y, m - 1, d);
      if (Number.isNaN(dt.getTime())) return null;
      if (
        dt.getFullYear() !== y ||
        dt.getMonth() !== m - 1 ||
        dt.getDate() !== d
      ) {
        return null;
      }
      return dt;
    },

    daysBetween(from, to) {
      const start = new Date(
        from.getFullYear(),
        from.getMonth(),
        from.getDate()
      );
      const end = new Date(to.getFullYear(), to.getMonth(), to.getDate());
      const diffMs = end.getTime() - start.getTime();
      return Math.floor(diffMs / (1000 * 60 * 60 * 24));
    },

    validateDateRange(fromDateStr, toDateStr) {
      const from = this.parseDDMMYYYY(fromDateStr);
      const to = this.parseDDMMYYYY(toDateStr);
      /*
      if (!from || !to) {
        this.$notify({ code: 1, message: "Invalid date format" });
        return false;
      }
      if (from.getTime() > to.getTime()) {
        this.$notify({
          code: 1,
          message: "`From` date must be before `To` date",
        });
        return false;
      }
      const days = this.daysBetween(from, to);
      if (days > 30) {
        this.$notify({ code: 1, message: "Only allow search within 30 days" });
        return false;
      }
      */
      return true;
    },

    handleGetListHistoryEsimABA(isLoadMore) {
      if (this.isFinished || this.isLoading) return;
      const currentPage = this.searchParams.pageNumber;
      if (this.requestedPages.has(currentPage)) return;
      this.requestedPages.add(currentPage);
      this.isLoading = true;

      if (
        !this.validateDateRange(
          this.searchParams.fromDate,
          this.searchParams.toDate
        )
      ) {
        this.isLoading = false;
        return;
      }

      let params = {};
      if (this.defaultParam) {
        const defaultParam = this.stateAsObject(this.defaultParam);
        const statusVal = Array.isArray(this.searchParams.status)
          ? this.searchParams.status[0] || ""
          : this.searchParams.status || "";
        params = {
          ...defaultParam,
          fromDate: this.searchParams.fromDate,
          toDate: this.searchParams.toDate,
          status: statusVal,
          orderCode: this.searchParams.orderCode || "",
          msisdn: this.searchParams.phoneNumber || "",
          transactionType: this.searchParams.transactionType || "",
          pageNumber: String(this.searchParams.pageNumber),
          pageSize: String(this.searchParams.pageSize),
        };
      }

      let account = "";
      if (this.profile) {
        account = this.profile.appId;
      }

      params.accountABA = account;

      if (!params.accountABA) {
        this.isLoading = false;
        return;
      }

      this.$store
        .dispatch("esimMetfoneStore/getHistories", params)
        .then((res) => {
          if (res) {
            const result = res.data;

            if (result.errorCode === 0) {
              this.totalOrder =
                result.totalOrder ?? result.total ?? result.totalCount ?? 0;

              const newOrders = this.normalizeHistoryList(result);
              const pageSizeNum = Number(this.searchParams.pageSize) || 10;

              const combinedOrders = isLoadMore
                ? [...this.listOrderEsimABA, ...newOrders]
                : newOrders;
              this.listOrderEsimABA = this.dedupeOrderList(combinedOrders);

              if (newOrders.length < pageSizeNum) {
                this.isFinished = true;
              } else {
                this.isFinished = false;
                this.searchParams.pageNumber += 1;
              }
            } else {
              this.$notify({
                code: res?.data?.errorCode,
                message: res?.data?.message || "Unknown error",
              });
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.totalOrder = this.listOrderEsimABA.length;
        });
    },
  },
};
</script>
<style>
.bage-success {
  background-color: #44ca83;
  width: 10px;
  height: 10px;
  border-radius: 5px;
}

.bage-Failed {
  background-color: #c41627;
  width: 10px;
  height: 10px;
  border-radius: 5px;
}

.bage-waiting {
  background-color: #3e7bfa;
  width: 10px;
  height: 10px;
  padding: 5px;
  border-radius: 5px;
}

.van-picker-column__wrapper {
  padding-left: 0;
}

.van-field__right-icon .van-icon-edit {
  color: #3d6eac;
}

.van-field__right-icon .van-icon-play {
  color: #000;
}

.van-field__right-icon .van-icon-play::before {
  transform: rotate(90deg);
  border-radius: 5px;
}

.van-field {
  border-color: #ccc !important;
}
</style>